// --- Helper Data for Random Generation ---
const firstNames = [
  "Aarav", "Vivaan", "Aditya", "Vihaan", "Arjun", "Sai", "Reyansh", "Ayaan", "Krishna", "Ishaan",
  "Diya", "Saanvi", "Ananya", "Aadhya", "Pari", "Myra", "Riya", "Aarohi", "Anayra", "Saira",
  "John", "Emma", "Olivia", "Noah", "Liam", "Sophia", "Mason", "Isabella", "James", "Ava"
];

const lastNames = [
  "Sharma", "Verma", "Gupta", "Malik", "Mehta", "Singh", "Patel", "Reddy", "Nair", "Kapoor",
  "Johnson", "Smith", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis", "Rodriguez", "Martinez"
];

const sampleMessages = [
  "Hey, kahan ho?", "Call me when free.", "Meeting at 5 PM?", "Project update?", "Ok, done.",
  "See you tomorrow!", "Sent the files.", "Happy Birthday! 🎂", "Let's catch up.", "Good morning!",
  "Are you coming?", "Please check email.", "Nice DP!", "Payment received.", "Lol 😂"
];

// --- Helper Functions ---
const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];
const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Function to generate fake data
const generateData = (count) => {
  const chats = [];
  const messages = {};

  for (let i = 1; i <= count; i++) {
    // 1. Generate Random Name
    const name = `${getRandomItem(firstNames)} ${getRandomItem(lastNames)}`;
    
    // 2. Generate Random Avatar (using pravatar.cc)
    // Pravatar supports index 1-70 generally
    const avatar = `https://i.pravatar.cc/150?img=${getRandomInt(1, 70)}`;

    // 3. Generate Random Messages for this user
    const userMessages = [];
    const msgCount = getRandomInt(2, 15); // Har user ke paas 2 se 15 messages honge

    for (let j = 1; j <= msgCount; j++) {
      userMessages.push({
        id: j,
        text: getRandomItem(sampleMessages),
        sender: Math.random() > 0.5 ? 'me' : 'them', // 50% chance me, 50% them
        time: `${getRandomInt(1, 12)}:${getRandomInt(10, 59)} ${Math.random() > 0.5 ? 'AM' : 'PM'}`,
        isRead: true
      });
    }

    // 4. Set Last Message info for Chat List
    const lastMsgObj = userMessages[userMessages.length - 1];

    chats.push({
      id: i,
      name: name,
      avatar: avatar,
      lastMessage: lastMsgObj.text,
      lastTime: lastMsgObj.time
    });

    messages[i] = userMessages;
  }

  return { chats, messages };
};

// --- Execute Generation (500 Users) ---
const generatedData = generateData(500);

export const initialChats = generatedData.chats;
export const initialMessages = generatedData.messages;